import React from 'react';

import api from '../../../../services';

import AutoComplete from 'material-ui/AutoComplete';
import { Checkbox } from 'material-ui';

class RegisterClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            classes: [],
        };

        this.changeAutoComplete = this.changeAutoComplete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
    }

    changeAutoComplete(searchText) {
        this.props.changeField([
            {
                field: 'registerClass.name',
                value: searchText,
            },
            {
                field: 'registerClass._id',
                value: '',
            },
            {
                field: 'registerClass.iacsRegister',
                value: false,
            },
        ]);

        this.setState({
            classes: [],
        }, async () => {
            if (!this.props.registerClass._id && searchText) {
                this.props.changeField([{
                    field: 'errors',
                    value: {
                        field: 'registerClass',
                        messages: ['Please select register class from dropdown'],
                    },
                    type: 'array',
                }]);
            }
            if (searchText) {
                await api.findClasses(searchText)
                    .then((response) => {
                        if (response.status === 200) {
                            const regClasses = response.data.data.map(regClass => ({
                                name: regClass.name,
                                regClass,
                            }));

                            if (!regClasses.length) {
                                this.setState({
                                    classes: [],
                                });

                                this.props.changeField({
                                    field: 'registerClass._id',
                                    value: '',
                                });
                            } else {
                                this.setState({
                                    classes: regClasses,
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Error AutoComplete Register classes - RegisterClass component', error);
                        return null;
                    });
            } else {
                this.props.clearError('registerClass');
            }
        });
    }

    chooseAutoComplete(updateProperties) {
        this.setState({
            classes: [],
        });

        this.props.changeField([{
            field: 'registerClass',
            value: updateProperties.regClass,
        }]);

        this.props.clearError('registerClass');
    }

    render() {
        const { classes } = this.state;
        const { getError, confirmed, underStyle, registerClass } = this.props;

        const checked = !!registerClass.iacsRegister;
        const disabled = !!registerClass.name;

        return (
            <div style={{ display: 'flex' }}>
                <AutoComplete
                    name='registerClass'
                    disabled={confirmed}
                    floatingLabelText='Register Class(Class)'
                    searchText={registerClass.name}
                    dataSource={classes}
                    dataSourceConfig={{ text: 'name', value: 'registerClass' }}
                    onUpdateInput={this.changeAutoComplete}
                    onNewRequest={this.chooseAutoComplete}
                    filter={AutoComplete.noFilter}
                    errorText={getError('registerClass')}
                    listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                    style={{ width: '70%' }}
                    fullWidth

                    underlineStyle={underStyle}
                />
                <Checkbox 
                    style={{ width: '30%', margin: '40px 0 0 20px' }}
                    label='IACS'
                    checked={checked}
                    disabled={disabled}
                    onCheck={() => this.props.changeField([{ field: 'registerClass.iacsRegister', value: !registerClass.iacsRegister }])}
                />
            </div>
        );
    }
}

export default RegisterClass;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/RegisterClass.jsx